export default function insights_filter() {
	let apply_filters = document.getElementById('apply-filters');

	if ( apply_filters ) {
		// Attach click even to apply filters button
		apply_filters.addEventListener('click', function(e) {
			e.preventDefault();

			let segment_filters = document.querySelectorAll('input[name="segment"]:checked');
			let type_filters   = document.querySelectorAll('input[name="category"]:checked');

			let search_params = '/esg-global/insights';
			let segment_params  = [];
			let type_params   = [];

			if ( segment_filters.length ) {
				segment_filters.forEach(segment_filter => {
					segment_params.push( segment_filter.value );
				});

				segment_params = segment_params.join('+');

				search_params += "/segment/" + segment_params
			}

			if ( type_filters.length ) {
				type_filters.forEach(type_filter => {
					type_params.push( type_filter.value );
				} );

				type_params = type_params.join('+');

				search_params += "/category/" + type_params
			}

			let search_url = window.location.origin + search_params;

			window.location = search_url;
		});
	}
}